import { useEffect, useState } from "react";
import "./SportRouteDetail.scss";
import "../SportRoutes/Components/RouteYouEmbed/RouteYouStyles.scss";
import { Carousel } from "../Carousel/Carousel";

export default function SportRouteDetail(props) {
  const { routeData, dictionary } = props;

  const [routeDetails, setRouteDetails] = useState();
  const [showAllImages, setShowAllImages] = useState(false);
  const [startPlaces, setStartPlaces] = useState([]);
  const [title, setTitle] = useState("");
  const [loop, setLoop] = useState("");
  const [media, setMedia] = useState([]);
  const [url, setUrl] = useState("");
  const [thumbnail, setThumbnail] = useState([
    "maxresdefault",
    "mqdefault",
    "sddefault",
    "hqdefault",
    "default",
  ]);
  const [clickedImageIndex, setClickedImageIndex] = useState(0);

  useEffect(() => {
    setRouteDetails(routeData);
    getStartPlaces(routeData);
    splitTitle(routeData);
    getMedia(routeData);
  }, []);

  const getStartPlaces = (data) => {
    let startplaces = [];
    data.pois.forEach((poi) => {
      if (poi.location?.type && poi.location.type.id == 123) {
        startplaces.push(poi.location);
      }
    });
    setStartPlaces(startplaces);
  };

  const getMedia = (data) => {
    let media = [];
    data.media.forEach((el) => {
      if (el.source?.name?.nl && el.source.name.nl === "YouTube") {
        //Yt vid
        media.push(prepYtVideo(el));
      } else {
        //Foto
        if (el?.uri?.nl) {
          media.push(prepImage(el));
        }
      }
    });
    setMedia(media);
  };

  const prepYtVideo = (media) => {
    if (media.content?.nl) {
      setUrl(
        "https://img.youtube.com/vi/" + media.content.nl + "/maxresdefault.jpg"
      );
    } else {
      setUrl(null);
    }
    return {
      type: "youtube",
      url: media.uri?.nl ? media.uri.nl : null,
    };
  };

  const prepImage = (media) => {
    return {
      type: "image",
      image: media.uri?.nl ? changeDimensions(media.uri.nl) : null,
    };
  };

  const changeDimensions = (url) => {
    const newDimensions = "1200x900";
    const modifiedUrl = url.replace(/\/\d+x\d+\//, `/${newDimensions}/`);

    return modifiedUrl;
  };

  const convertTypeToIcon = (type) => {
    let image = "";
    let baseUrl = "/images/listviewIcons";
    let suffix = ".svg";
    switch (type) {
      case 9:
      case 25:
      case 26:
      case 49:
        image = `${baseUrl}/runIcon${suffix}`;
        break;

      case 17:
      case 35:
      case 36:
        image = `${baseUrl}/horsebackIcon${suffix}`;
        break;

      case 7:
        image = `${baseUrl}/mountainbikeIcon${suffix}`;
        break;

      case 16:
      case 32:
        image = `${baseUrl}/kayakIcon${suffix}`;
        break;

      case 19:
        image = `${baseUrl}/skateIcon${suffix}`;
        break;

      case 2:
      case 4:
      case 8:
        image = `${baseUrl}/multiMoveIcon${suffix}`;
        break;
    }
    return image;
  };

  const splitTitle = (data) => {
    var title = "";
    if (data.name.nl) {
      title = data.name.nl;

      const delimiter = title.includes("•")
        ? "•"
        : title.includes("-")
        ? "-"
        : null;
      if (delimiter) {
        const split = title.split(delimiter);
        setTitle(split.slice(0, -1).join(delimiter));
        setLoop(split.slice(-1)[0]);
      } else {
        setTitle(title);
        setLoop("");
      }
    }
  };

  const checkRouteTypeHoogteMeters = () => {
    var show = true;
    if (routeDetails?.type?.id) {
      switch (routeDetails.type.id) {
        case 16:
        case 32:
          show = false;
          break;
        case 19:
          show = false;
          break;
        case 2:
        case 4:
        case 8:
          show = false;
          break;
      }
    }
    return show;
  };

  const navigateBack = () => {
    //window.history.back();
    const url = window.location.href;
    const splits = url.split(`route/${routeData.id}/`);
    window.location.href = `${splits[0]}` + `${splits[1]}`;
  };

  const closeOverlay = () => {
    var overlay = document.querySelector(".overlay");
    var carousel = document.querySelector(".c-routedetail-carousel__container");
    if (overlay && carousel) {
      document.body.classList.remove("u-noscroll");
      overlay.style.display = "none";
      carousel.style.display = "none";
    }
  };

  const openOverlay = (index) => {
    setClickedImageIndex(index);
    var overlay = document.querySelector(".overlay");
    var carousel = document.querySelector(".c-routedetail-carousel__container");
    if (overlay && carousel) {
      document.body.classList.add("u-noscroll");
      overlay.style.display = "block";
      carousel.style.display = "flex";
    }
  };

  const checkThumbnail = (e) => {
    var imageUrl = e.target.src;

    if (imageUrl === null) {
      return;
    }

    if (e.target.naturalWidth === 120 && e.target.naturalHeight === 90) {
      for (let i = 0; i < thumbnail.length - 1; i++) {
        if (imageUrl.indexOf(thumbnail[i]) > 0) {
          setUrl(imageUrl.replace(thumbnail[i], thumbnail[i + 1]));
          break;
        }
      }
    }
  };

  const extractCoordinates = (coordinates) => {
    // coordinates format: {wkt: 'POINT(4.901845 51.21313)}
    const coords = coordinates.match(/\((.*)\)/)?.pop();
    const coordsArray = coords.split(" ");

    return `${coordsArray[1]} ${coordsArray[0]}`;
  };

  return (
    <div className="c-routedetail__container js-routeDetail">
      <div className="c-routedetail-return__container">
        <i
          onClick={navigateBack}
          className="fal fa-arrow-left c-routedetail-return__arrow"
        ></i>
        <a onClick={navigateBack} className="c-routedetail-return">
          Terug
        </a>
      </div>

      <div>
        <h2 className="c-routedetail-title">{title}</h2>
      </div>

      <div className="u-align u-gap-1rem">
        <img
          className="c-routedetail-description__icon"
          src={routeDetails ? convertTypeToIcon(routeDetails.type.id) : ""}
        />
        <h5 className="u-primary-color">{loop}</h5>
      </div>

      <div className="c-routedetail-configuration__container">
        {routeDetails?.length && (
          <div>
            <p className="c-routedetail-configuration__text">Afstand</p>

            <strong>{(routeDetails.length / 1000).toFixed(2) + "km"}</strong>
          </div>
        )}

        {(checkRouteTypeHoogteMeters() && routeDetails?.ascent?.total) ||
        (checkRouteTypeHoogteMeters() && routeDetails?.descent?.total) ? (
          <div>
            <p className="c-routedetail-configuration__text">Hoogtemeters</p>

            {routeDetails?.ascent?.total ? (
              <strong>{routeDetails?.ascent?.total + "m"}</strong>
            ) : (
              <strong>{routeDetails?.descent?.total + "m"}</strong>
            )}
          </div>
        ) : (
          <></>
        )}

        {routeDetails?.statistics?.roadCondition?.unpaved &&
          routeDetails?.type?.id != 19 && (
            <div>
              <p className="c-routedetail-configuration__text">Onverhard</p>

              <strong>
                {(
                  (routeDetails.statistics.roadCondition.unpaved.good +
                    routeDetails.statistics.roadCondition.unpaved.bad) *
                  100
                ).toFixed(2) + "%"}
              </strong>
            </div>
          )}

        {routeDetails?.type?.id == 7 &&
        routeDetails?.statistics?.singletrack?.score ? (
          <div>
            <p className="c-routedetail-configuration__text">Single tracks</p>

            <strong>
              {Math.round(routeDetails.statistics.singletrack.score * 100) +
                "%"}
            </strong>
          </div>
        ) : (
          <></>
        )}
      </div>

      <div id="routeYouRouteViewerMap" className="c-routedetail-map"></div>

      <div className="u-split-screen">
        <div className="u-split-screen__half">
          <h3 className="c-routedetail-description-title">
            {dictionary.routeOmschrijving}
          </h3>

          <div>
            {routeDetails && (
              <div
                dangerouslySetInnerHTML={{
                  __html: routeDetails.description.nl,
                }}
              ></div>
            )}
          </div>

          {routeDetails && routeDetails?.generatedInfo?.nl && (
            <div
              dangerouslySetInnerHTML={{
                __html: routeDetails.generatedInfo.nl,
              }}
            ></div>
          )}

          <div className="c-routedetail-startplaces__container">
            <p className="c-routedetail-startplace-title">
              <strong>{dictionary.startplaatsen}</strong>
            </p>

            {startPlaces.length > 0 && (
              <div>
                {startPlaces.map((startplace, index) => (
                  <div
                    className="c-routedetail-startplace__container"
                    key={index}
                  >
                    <i className="fa-solid fa-flag-checkered"></i>
                    {startplace?.centroid?.wkt ? (
                      <a
                        className="c-routedetail-startplace-text"
                        href={`https://www.google.com/maps/place/${extractCoordinates(
                          startplace.centroid.wkt
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {startplace.address.street} {startplace.address.number}{" "}
                        {startplace.address.postalCode}{" "}
                        {startplace.address.city}
                      </a>
                    ) : startplace?.address ? (
                      <a
                        className="c-routedetail-startplace-text"
                        href={`https://www.google.com/maps/place/${startplace.address.street} ${startplace.address.number} ${startplace.address.postalCode} ${startplace.address.city}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {startplace.address.street} {startplace.address.number}{" "}
                        {startplace.address.postalCode}{" "}
                        {startplace.address.city}
                      </a>
                    ) : (
                      <a
                        className="c-routedetail-startplace-text"
                        href={`https://www.google.com/maps/place/${
                          startplace.name.nl.split("Startplaats")[1]
                        }`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {startplace.name.nl}
                      </a>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          {routeDetails ? (
            media.length > 0 ? (
              <div className="c-routedetail-description-dropdown__container">
                <div id="routeYouRouteViewerTabPane"></div>
              </div>
            ) : (
              <></>
            )
          ) : (
            <></>
          )}
        </div>

        <div className="u-split-screen__half">
          {routeDetails ? (
            media.length > 0 ? (
              <>
                <div
                  className={`c-routedetail-description-grid ${
                    showAllImages ? "" : "u-limit-grid"
                  }`}
                >
                  {media.map((item, index) => {
                    switch (item.type) {
                      case "youtube":
                        return (
                          <a href={item.url} className="c-routedetail-yt">
                            <img
                              onLoad={(e) => checkThumbnail(e)}
                              src={url}
                              alt={`Image ${index}`}
                              key={index}
                              className="c-routedetail-description-grid__image"
                            />
                            <div className="play-button">
                              <div className="play-button__icon"></div>
                            </div>
                          </a>
                        );
                      case "image":
                        return (
                          <img
                            src={item.image}
                            alt={`Image ${index}`}
                            key={index}
                            className="c-routedetail-description-grid__image"
                            onClick={() => openOverlay(index)}
                          />
                        );
                      case "pdf":
                        return (
                          <object
                            key={index}
                            data={item.url}
                            type="application/pdf"
                            width="100%"
                            height="500px"
                          >
                            <p>
                              It appears you don't have a PDF plugin for this
                              browser. No biggie... you can{" "}
                              <a href={item.url}>
                                click here to download the PDF file.
                              </a>
                            </p>
                          </object>
                        );
                      default:
                        return null;
                    }
                  })}
                </div>

                {media.length > 9 ? (
                  <div className="u-margin-top-1x u-align">
                    <i className="fal fa-arrow-right u-primary-color"></i>
                    <button
                      className="c-routedetail-description-grid__button"
                      onClick={() => {
                        setShowAllImages(!showAllImages);
                      }}
                    >
                      {showAllImages
                        ? dictionary.verbergFotos
                        : dictionary.alleFotos}
                    </button>
                  </div>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <>
                <div className="c-routedetail-description-dropdown__container">
                  <div id="routeYouRouteViewerTabPane"></div>
                </div>
              </>
            )
          ) : (
            <></>
          )}
        </div>
      </div>

      <div
        className="c-routedetail-carousel__container"
        style={{ display: "none" }}
      >
        <i class="fa fa-close overlay-close" onClick={closeOverlay}></i>
        <Carousel data={media} index={clickedImageIndex} />
      </div>
      <div className="overlay" style={{ display: "none" }}></div>
    </div>
  );
}
